import { render } from "./OurPartner.vue?vue&type=template&id=9d769d78"
import script from "./OurPartner.vue?vue&type=script&lang=js"
export * from "./OurPartner.vue?vue&type=script&lang=js"

import "./OurPartner.vue?vue&type=style&index=0&id=9d769d78&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__